// extracted by mini-css-extract-plugin
module.exports = {"staticPageWrapper":"BecomeAGuestPage_staticPageWrapper__3Hwuk"};